import React from "react";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-error-fallback" className="min-h-screen flex items-center justify-center bg-[#0A0A0B] text-white p-6">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-2xl font-semibold">Something went wrong loading this page</h1>
          <p className="text-sm text-gray-400">{String(this.state.error?.message || this.state.error)}</p>
          <div className="flex gap-3 justify-center">
            <button data-testid="app-error-reload-btn" onClick={() => window.location.reload()} className="px-5 py-2 rounded-full bg-cyan-500 text-black font-medium hover:bg-cyan-400 transition-colors">Reload</button>
            <button data-testid="app-error-dashboard-btn" onClick={() => { window.location.href = "/dashboard"; }} className="px-5 py-2 rounded-full border border-gray-600 hover:bg-gray-800 transition-colors">Go to Dashboard</button>
          </div>
        </div>
      </div>
    );
  }
}
